class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);

    document.addEventListener('click', (event) => {
      const clearBtn = event.target.closest('.custom-clear-filter');
      if (clearBtn) {
        event.preventDefault();
        const filterName = clearBtn.getAttribute('data-filter-name');
        
        document.querySelectorAll(`input[name="${filterName}"]`).forEach((input) => {
          input.checked = false;
        });
        
        const activeForm = clearBtn.closest('form') || document.querySelector('#FacetFiltersForm') || document.querySelector('#FacetFiltersFormMobile');
        if (activeForm) {
          const formElement = activeForm.closest('facet-filters-form') || document.querySelector('facet-filters-form');
          if (formElement) {
            formElement.onSubmitHandler({
              preventDefault: () => {},
              target: activeForm,
              srcElement: {}
            });
          } else {
            activeForm.submit();
          }
        }
      }
    });
    
    FacetFiltersForm.applyCustomFrontendFilters();
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    }
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer){
      countContainer.classList.add('loading');
    }
    
    if (countContainerDesktop){
      countContainerDesktop.parentElement.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl) ?
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) :
        FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;
    FacetFiltersForm.applyCustomFrontendFilters();
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.parentElement.classList.remove('loading');
    }
    FacetFiltersForm.applyCustomFrontendFilters();
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements =
      parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter');
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    }
    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      const target = document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`);
      if (target) {
        target.innerHTML = element.innerHTML;
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
    
    FacetFiltersForm.applyCustomFrontendFilters();
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    })

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    const targetElementAccessibility = target.querySelector('.facets__summary');
    const sourceElementAccessibility = source.querySelector('.facets__summary');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
    }
    
    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');
    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }
      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
    
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      }
    ]
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'))
      this.onSubmitForm(searchParams, event)
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm' || form.id === 'FacetFilterActiveForm') {
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event)
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }

  static applyCustomFrontendFilters() {
    const urlParams = new URLSearchParams(window.location.search);
    
    const activeColors = [
      ...urlParams.getAll('filter.p.m.shopify.color'),
      ...urlParams.getAll('filter.p.m.shopify.colour')
    ].map(v => v.toLowerCase().trim()).filter(Boolean);
    
    const activeSizes = urlParams.getAll('filter.p.m.shopify.size').map(v => v.toLowerCase().trim()).filter(Boolean);

    // Sync color checkboxes
    document.querySelectorAll('input[name="filter.p.m.shopify.color"]').forEach((input) => {
      const isChecked = activeColors.includes(input.value.toLowerCase().trim());
      input.checked = isChecked;
      const label = input.closest('.facet-checkbox') || input.closest('.mobile-facets__label');
      if (label) {
        label.classList.toggle('active', isChecked);
      }
    });

    // Sync size checkboxes
    document.querySelectorAll('input[name="filter.p.m.shopify.size"]').forEach((input) => {
      const isChecked = activeSizes.includes(input.value.toLowerCase().trim());
      input.checked = isChecked;
      const label = input.closest('.facet-checkbox') || input.closest('.mobile-facets__label');
      if (label) {
        label.classList.toggle('active', isChecked);
      }
    });
    
    const productCards = document.querySelectorAll('.product-grid-item-card');
    let visibleCount = 0;
    
    productCards.forEach((card) => {
      const cardColorsStr = card.getAttribute('data-colors') || '';
      const cardSizesStr = card.getAttribute('data-sizes') || '';
      
      const cardColors = cardColorsStr.split('::').map(v => v.trim().toLowerCase()).filter(Boolean);
      const cardSizes = cardSizesStr.split('::').map(v => v.trim().toLowerCase()).filter(Boolean);
      
      let showColor = true;
      if (activeColors.length > 0) {
        showColor = cardColors.some(color => activeColors.includes(color));
      }
      
      let showSize = true;
      if (activeSizes.length > 0) {
        showSize = cardSizes.some(size => activeSizes.includes(size));
      }
      
      if (showColor && showSize) {
        card.style.display = '';
        visibleCount++;
      } else {
        card.style.display = 'none';
      }
    });

    const productCountText = document.querySelectorAll('#ProductCount, #ProductCountDesktop');
    productCountText.forEach((el) => {
      const countSpan = el.querySelector('#ProductCountText');
      if (countSpan) {
        countSpan.textContent = `${visibleCount} products`;
      } else {
        el.textContent = `${visibleCount} products`;
      }
    });
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    
    const minSlider = this.querySelector('.min-range-slider');
    const maxSlider = this.querySelector('.max-range-slider');
    const inputs = this.querySelectorAll('input.price__filter_input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    const rangeSelected = this.querySelector('.range-selected');
    const minDisplay = this.querySelector('.min-price-display');
    const maxDisplay = this.querySelector('.max-price-display');

    if (minSlider && maxSlider && minInput && maxInput) {
      const maxVal = parseFloat(minSlider.max) || 100;
      
      const updateSliderDisplayOnly = () => {
        let minVal = parseFloat(minSlider.value);
        let maxValCurrent = parseFloat(maxSlider.value);
        
        if (minVal > maxValCurrent) {
          let temp = minVal;
          minVal = maxValCurrent;
          maxValCurrent = temp;
        }
        
        const leftPct = (minVal / maxVal) * 100;
        const rightPct = 100 - (maxValCurrent / maxVal) * 100;
        
        if (rangeSelected) {
          rangeSelected.style.left = leftPct + '%';
          rangeSelected.style.right = rightPct + '%';
        }
        
        const currencySymbol = window.Shopify && window.Shopify.currency ? (window.Shopify.currency.active === 'INR' ? '₹' : window.Shopify.currency.active) : '₹';
        if (minDisplay) minDisplay.textContent = currencySymbol + minVal;
        if (maxDisplay) maxDisplay.textContent = currencySymbol + maxValCurrent;
      };
      
      minSlider.addEventListener('input', () => {
        if (parseFloat(minSlider.value) > parseFloat(maxSlider.value)) {
          minSlider.value = maxSlider.value;
        }
        updateSliderDisplayOnly();
      });
      
      maxSlider.addEventListener('input', () => {
        if (parseFloat(maxSlider.value) < parseFloat(minSlider.value)) {
          maxSlider.value = minSlider.value;
        }
        updateSliderDisplayOnly();
      });

      minSlider.addEventListener('change', () => {
        minInput.value = minSlider.value;
        minInput.dispatchEvent(new Event('change', { bubbles: true }));
      });
      maxSlider.addEventListener('change', () => {
        maxInput.value = maxSlider.value;
        maxInput.dispatchEvent(new Event('change', { bubbles: true }));
      });
      
      updateSliderDisplayOnly();
    }

    inputs.forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input.price__filter_input');
    if (inputs.length < 2) return;
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', minInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);
